/**
 * @returns `'/path?search=value#hash'`
 */
export const getPathWithParams = (location = window.location) =>
  `${location.pathname}${location.search}${location.hash}`;
